// extracted by mini-css-extract-plugin
export var content = "_41-3";
export var list = "_41-4";
export var settingsContent = "_41-7";
export var settingsPanel = "_41-8";
export var state = "_41-6";
export var triggerBadge = "_41-2";
export var triggerButton = "_41-1";
export var triggerShell = "_41-0";
export var unreadDot = "_41-5";